exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pb-btn{background-color:#7246a0!important;border-color:#7246a0!important;color:#fff!important}.welcome-modal .modal-content{border-radius:0!important}.welcome-modal .modal-dialog{max-width:550px}.welcome-modal .modal-footer{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.welcome-modal .signup-iframe{width:100%;height:657px;border:none}.welcome-verify{margin-top:32px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-829b62fa","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/WelcomeModal.vue
// module id = GGcz
// module chunks = 1